// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ppEl","title":"styles_title__DZzRe"};